module.exports = __webpack_public_path__ + "static/media/section_2_i_1.855a6842.png";